import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const accessToken = sessionStorage.getItem('access_token');

  if (!accessToken) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}
